/*
 * 用法：
 * 1. 给可点击元素添加类名 `.cta-id-smooth`
 * 2. 用 `data-href` 传目标链接
 *    - 站内锚点滚动：`data-href="#discount-info"`
 *    - 带路径锚点：`data-href="/pages/chloe-kelly-sale#discount-info"`
 *    - 普通跳转：`data-href="/collections/all"`
 * 3. 可选偏移参数
 *    - `data-offset="20"`：额外减去 20px
 *    - `data-offset-section="shopify-section-header"` 或 `data-offset-section=".header-wrapper"`
 *      会自动减去对应元素高度，常用于 fixed header
 *      推荐用 `#id`（如 `#spring-sale-pre-nav`），避免 Shopify section class 与内部节点重名
 *
 * 示例：
 * <button
 *   class="cta-id-smooth"
 *   data-href="#discount-info"
 *   data-offset="12"
 *   data-offset-section="#spring-sale-pre-nav"
 * >
 *   Shop now
 * </button>
 */
(function () {
  // 多个 section 可能重复引入本脚本，只绑定一次
  if (window.__ctaIdSmoothBound) return;
  window.__ctaIdSmoothBound = true;

  // 最终偏移 = data-offset + data-offset-section 对应元素高度；没填或找不到都按 0
  // data-offset-section 支持选择器，如 .site-header、#site-header；也可填纯 id
  function getOffsetSectionEl(selector) {
    if (!selector) return null;

    var bareId = selector.charAt(0) === '#' ? selector.slice(1) : selector;
    var byId = document.getElementById(bareId);
    if (selector.charAt(0) === '#' && byId) return byId;
    if (selector.charAt(0) !== '.' && selector.charAt(0) !== '#' && byId) return byId;

    try {
      var nodes = document.querySelectorAll(selector);
      if (nodes.length === 1) return nodes[0];
      if (nodes.length > 1) {
        // Shopify schema class 会打在外层 wrapper 上，常与内部节点同 class。
        // 优先取带真实 id / 已吸顶 / 有高度的内部节点，避免量到高度为 0 的 wrapper。
        var i;
        var node;
        var withHeight = null;
        for (i = 0; i < nodes.length; i++) {
          node = nodes[i];
          if (node.id && node.id.indexOf('shopify-section-') === 0) continue;
          if (node.id === bareId || node.classList.contains('fixed')) return node;
          if (!withHeight && node.getBoundingClientRect().height > 0) withHeight = node;
        }
        if (withHeight) return withHeight;
        return nodes[nodes.length - 1];
      }
    } catch (e) {}

    return document.getElementById('shopify-section-' + bareId);
  }

  function getCtaOffset(link) {
    var offset = parseFloat(link.getAttribute('data-offset'));
    if (isNaN(offset)) offset = 0;

    var sectionSelector = (link.getAttribute('data-offset-section') || '').trim();
    if (!sectionSelector) return offset;

    var section = getOffsetSectionEl(sectionSelector);
    if (section) offset += section.getBoundingClientRect().height;

    return offset;
  }

  // JS 吸顶（先 position:static，再加 .fixed）且没有占位时：先进入吸顶终态再量距离，
  // 否则滚动过程中内容上跳，目标会被吸顶栏挡住，看起来像 offset 没生效。
  function pinOffsetSectionIfNeeded(section) {
    if (!section || section.classList.contains('fixed')) return;

    var position = window.getComputedStyle(section).position;
    if (position === 'fixed' || position === 'sticky') return;

    if (typeof window.__springSalePreNavSetFixed === 'function' &&
        (section.id === 'spring-sale-pre-nav' ||
          section.classList.contains('spring-sale-pre-nav'))) {
      window.__springSalePreNavSetFixed(true);
      return;
    }

    section.classList.add('fixed');

    if (
      section.id === 'spring-sale-pre-nav' ||
      section.classList.contains('spring-sale-pre-nav')
    ) {
      section.style.top = '0px';
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.cta-id-smooth');
    if (!link) return;

    var href = link.getAttribute('data-href') || '';
    if (!href) return;

    event.preventDefault();

    // 链接含 #：滚到对应 id；找不到目标则走下方跳转
    if (href.indexOf('#') !== -1) {
      var id = href.split('#').pop();
      var element = id && document.getElementById(id);
      if (element) {
        var sectionSelector = (link.getAttribute('data-offset-section') || '').trim();
        var offsetSection = sectionSelector ? getOffsetSectionEl(sectionSelector) : null;
        pinOffsetSectionIfNeeded(offsetSection);

        // lottery M 端负 margin overlap：跳到下方锚点前先推到终态再量
        if (typeof window.__pdPreLotteryPrepareOverlapForTarget === 'function') {
          window.__pdPreLotteryPrepareOverlapForTarget(element);
        }

        var top =
          element.getBoundingClientRect().top + window.pageYOffset - getCtaOffset(link);
        window.scrollTo({
          top: top,
          behavior: 'smooth',
        });
        return;
      }
    }

    // 不含 #，或锚点不存在：直接跳转
    window.location.href = href;
  });
})();
